import styled from '@emotion/styled';
export const Section = styled.div`
  label: JMT-General-Section;
  margin: 15px 0;
`;